import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from '../store/store'
import Results from "./Results.jsx"
import MobileImageElement from "./MobileImageElement.jsx"
import { setResults, setHasOpened, setRegionImage, setCountryImage } from '../store/eyewearResultsSlice'

document.addEventListener('DOMContentLoaded', () => {
  const resultsWrapper = document.querySelector('[data-eyewear-stores-list]')
  
  if(resultsWrapper) {
    const resultsRoot = createRoot(resultsWrapper)
    resultsRoot.render(<Provider store={store}>
      <Results />
    </Provider>)

    window.setEyewearStoreResults = (results, scoreThreshold=0.2, regionImage = null) => {
      store.dispatch(setHasOpened( false ))
      store.dispatch(setRegionImage(regionImage))
      store.dispatch(setCountryImage(null))
      console.log('results', results)
      store.dispatch(setResults(results.filter(result => result.score <= scoreThreshold)))
    }
  }

  const mobileHeroWrap = document.querySelector('[data-mobile-hero-image]')
  if(mobileHeroWrap) {
    const mobileHeroRoot = createRoot(mobileHeroWrap)
    mobileHeroRoot.render(<Provider store={store}>
      <MobileImageElement />
    </Provider>)
  }
})